import { AvailableLanguages } from '@repo/toolkit/language-types'
import { startOfDay } from 'date-fns'

import useTranslate from '../../../hooks/use-translate'
import { getTranslatedName } from '../../../utils/functions/translation.functions'
import { ProductTypeEnum } from '../../enums/product/product-type.enum'
import { Journey, JourneyLight, JourneyProgramLabel } from './journey'

export class JourneyProperties {
  static getJourneyLabel = (journey: JourneyLight) => {
    const { t } = useTranslate()

    const numberOfHoursPerWeek =
      journey.date.product.type === ProductTypeEnum.ONE_TO_ONE
        ? journey.date.product.numberOfHoursPerWeek
        : undefined

    const output: string[] = [journey.reference]

    if (numberOfHoursPerWeek !== undefined)
      output.push(t('product.number.of.hours.per.week', { hours: numberOfHoursPerWeek }))

    return output.join(' - ')
  }

  /** The journey as "formula - theme - options", e.g. "Intensive courses and activities - Multi-activity" */
  static getProgramLabel = (journey: JourneyProgramLabel, language: AvailableLanguages) => {
    return [
      getTranslatedName(journey.date.product.formula, language) || '—',
      getTranslatedName(journey.mainOption, language) || '—',
      ...journey.secondaryOptions.map(({ option }) => getTranslatedName(option, language) || '—')
    ].join(' - ')
  }

  static isCurrentlyInStay = (journey: {
    date: Pick<Journey['date'], 'departureDate' | 'returnDate'> & {
      period?: Pick<Journey['date']['period'], 'id'>
    }
  }) => {
    const today = new Date()
    const startDate = new Date(journey.date.departureDate)
    const endDate = new Date(journey.date.returnDate)
    return startOfDay(today) >= startOfDay(startDate) && startOfDay(today) <= startOfDay(endDate)
  }
}
